module.exports = __webpack_public_path__ + "static/media/max-k-15.fd400980.png";